import { Box } from "@mui/material";
import type { DateTime } from "luxon";
import type { FC } from "react";
import { NEUTRAL } from "../../../../theme/tokens";
import type { DayStats } from "../../../../utils/models";
import { SwatchLegend, type SwatchLegendItem } from "../../../UIToolkit/molecules/SwatchLegend";
import type { GapsPickupBonuses } from "../gapsPickupBonuses";
import type { GapsDayHppd } from "../useGapsDayModel";
import { GapsDayStatCells } from "./GapsDayStatCells";

type Props = {
	dayStats: DayStats | undefined;
	dayHppd: GapsDayHppd | undefined;
	pickupBonuses: GapsPickupBonuses | undefined;
	date: DateTime;
	legend: SwatchLegendItem[];
};

/**
 * The expanded drawer: the day's stats, then — as its last row — the key to the collapsed line's dots.
 *
 * The legend is drawn from the same `dots` map the line is, so a dot and its name cannot disagree. It
 * wraps rather than scrolls: it is the one place every job's name is spelled out, so none may be cut.
 */
export const GapsMetricsDetail: FC<Props> = ({ dayStats, dayHppd, pickupBonuses, date, legend }) => (
	<Box
		data-testid="gaps-metrics-detail"
		sx={{
			display: "grid",
			gridTemplateColumns: "1fr 1fr",
			rowGap: 0.875,
			columnGap: 1.5,
			px: 1.625,
			py: 1.25,
			bgcolor: NEUTRAL[50],
			borderTop: `1px solid ${NEUTRAL[150]}`,
		}}
	>
		{dayStats && <GapsDayStatCells dayStats={dayStats} dayHppd={dayHppd} pickupBonuses={pickupBonuses} date={date} />}
		{legend.length > 0 && (
			<SwatchLegend dense items={legend} dataTestId="gaps-metrics-legend" sx={{ gridColumn: "1 / -1", flexWrap: "wrap", rowGap: 0.5, columnGap: 1.5 }} />
		)}
	</Box>
);
